export default __webpack_public_path__ + "static/media/PrivateEvents5.b7302481.jpg";